import React from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
import clsx from 'clsx'
import styles from './InboxHeader.module.css'

interface InboxHeaderProps {
  searchInput: string
  onSearchChange: (search: string) => void
  onFilterClick: () => void
  onEditClick: () => void
  selectedCount: number
  onBulkActionsClick: () => void
}

const InboxHeader: React.FC<InboxHeaderProps> = ({
  searchInput,
  onSearchChange,
  onFilterClick,
  selectedCount,
  onBulkActionsClick,
}) => {
  return (
    <div className={clsx('d-flex gap-3 p-3 flex-column', styles.headerContainer)}>


      <div className='d-flex gap-3'>
        {/* Search Input */}
        <div className={clsx('position-relative flex-grow-1', styles.searchContainer)}>
          <KTSVG
            path='/media/icons/duotune/general/gen021.svg'
            className={clsx('svg-icon-2 position-absolute', styles.searchIcon)}
          />
          <input
            type='text'
            className={clsx('form-control form-control-sm', styles.searchInput)}
            placeholder='Search'
            value={searchInput}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>

        {/* Filter and Edit Icons */}
        <div className='d-flex align-items-center gap-2'>
          <button
            className={clsx('btn btn-sm btn-icon btn-light', styles.iconButton)}
            onClick={onFilterClick}
            title='Quick Filters'
            aria-label='Open quick filters'
          >
            <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-3' />
          </button>

        </div>
      </div>

      <div className='d-flex flex-2'>
        {/* Bulk Actions Button - Only show when items are selected */}
        {/* Changes in 9/2/26 - Show it even when no items are selected */}
          <button
            className='btn btn-primary btn-sm dropdown-toggle d-flex align-items-center gap-2'
            onClick={onBulkActionsClick}
            aria-label={`Actions for ${selectedCount} selected items`}
          >
            <span>Actions</span>
            <span className='badge badge-light text-primary fw-bold'>
              {selectedCount}
            </span>
          </button>
      </div>
    </div>
  )
}

export default InboxHeader
